import { isEqual } from 'lodash';

/**
 * Checks if the delay property has changed between current and initial blocks.
 * Uses deep equality comparison to handle complex delay values.
 *
 * @param {Object} currentBlock - The current block object that may contain a delay property
 * @param {Object} initialBlock - The initial block object to compare against
 * @returns {boolean} Returns true if delay values are different, false if they are equal
 *
 * @example
 * // Basic usage with primitive values
 * const current = { delay: 1000 };
 * const initial = { delay: 500 };
 * isDelayChanged(current, initial); // true
 *
 * @example
 * // No change detected
 * const current = { delay: 1000 };
 * const initial = { delay: 1000 };
 * isDelayChanged(current, initial); // false
 *
 * @example
 * // Handles undefined/null blocks safely
 * isDelayChanged(null, { delay: 100 }); // true
 * isDelayChanged({ delay: 100 }, undefined); // true
 * isDelayChanged(null, null); // false
 *
 * @example
 * // Works with complex delay objects
 * const current = { delay: { value: 100, unit: 'ms' } };
 * const initial = { delay: { value: 100, unit: 'ms' } };
 * isDelayChanged(current, initial); // false
 *
 * @example
 * // Missing delay properties
 * const current = { name: 'block1' }; // no delay property
 * const initial = { delay: 100 };
 * isDelayChanged(current, initial); // true
 */
export const isDelayChanged = (currentBlock, initialBlock) => !isEqual(currentBlock?.delay, initialBlock?.delay);
